import React, { useEffect, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SecureStore from "react-secure-storage";

import { toast } from 'react-toastify';

import * as APIS from "./utils/service";

import { useUser, useLang, useMenu, usePopup } from "./zustand/store.js";

import routes from "./libs/routes";

import Header from "./components/Header";

import Main from "./pages/Main";
import Login from "./pages/Login";

import Menu1 from "./pages/Menu1";
import Menu2 from "./pages/Menu2";
import Menu3 from "./pages/Menu3";
import Menu4 from "./pages/Menu4";
import Menu5 from "./pages/Menu5";
import Menu6 from "./pages/Menu6";
import Menu7 from "./pages/Menu7";
import Menu8 from "./pages/Menu8";
import Menu9 from "./pages/Menu9";
import Menu10 from "./pages/Menu10";

import Profile from "./pages/Profile";
import Pay from "./pages/Pay";
import PayHistory from "./pages/PayHistory";

import ArtHistory from "./pages/ArtHistory.js";

import Term from "./pages/Term";
import ArtGallery from './pages/ArtGallery.js';
import ArtDetail from './pages/ArtDetail.js';
import ErrorPage from './pages/ErrorPage.js';

import PayLoading from "./pages/pay/PayFail"
import PayFail from "./pages/pay/PayFail"

function Router() {

    /* 빌드시 주석해제 */
    // console = {};
    // console.log = function(){};
    // console.warn = function(){};
    // console.error = function(){};


    const { isReload, token, setUser } = useUser();
    const { country, setLang } = useLang();
    const { menu, setMenu } = useMenu();
    const { menuPop } = usePopup();


    useEffect(() => {

        menuDataFunc();
        optionDataFunc();
        userDataFunc();

    }, [])

    useEffect(() => {
        console.log('country', country);

        langDataFunc();
    }, [country])

    useEffect(() => {
        if (isReload) {
            menuDataFunc(); // 메뉴 설정 정보
            optionDataFunc(); // 옵션 정보
            userDataFunc(); // 회원 정보
        }
    }, [isReload])

    const langDataFunc = () => {
        APIS.post('/config/lang').then(({ data }) => {
            console.log('data', data);

            // SecureStore.setItem('lang', data);
            setLang({
                key: 'lang',
                value: data
            })

        }).catch((e) => {
            console.log(e.response.data);
        });
    }

    const menuDataFunc = () => {
        //TODO: 메뉴리스트 고정 해제
        APIS.post('/config/menuList').then(({ data }) => {
            console.log('data', data);
            setMenu({
                key: 'menu',
                value: data
                // value: [...data, {
                //     "idx": 10,
                //     "index": 10,
                //     "name_key": "menu_name10",
                //     "title_key": "menu_title10",
                //     "type": "video",
                //     "info_key": "menu_info10",
                //     "image": {
                //         "ko": "/images/1976a6d7-c4c0-47d5-9f84-6a2c1164172c.png",
                //         "en": "/images/42e12020-da29-486a-a91e-f8bc6e81b304.png"
                //     },
                //     "icon": "/icons/generateVideo.svg",
                //     "point": 2000000,
                //     "limit": 20,
                //     "share": true
                // }]
            })
        }).catch((e) => {
            console.log(e.response.data);
        });
    }

    const optionDataFunc = () => {

        APIS.post('/config/option').then(({ data }) => {
            console.log('data', data);

        }).catch((e) => {
            console.log(e.response.data);
        });
    }

    const userDataFunc = () => {

        if (!token) return;

        APIS.post('/user/config').then(({ data }) => {
            setUser({
                key: 'user',
                value: data
            })
        }).catch((e) => {
            console.log(e.response.data);
        });
    }

    return (
        <>
            <BrowserRouter>

                <Header />

                <Routes>

                    <Route exact path={routes.main} element={<Main />} />

                    <Route exact path={routes.menu_1} element={menu?.find(x => x.idx === 1) ? <Menu1 /> : <ErrorPage />} />
                    <Route exact path={routes.menu_2} element={menu?.find(x => x.idx === 2) ? <Menu2 /> : <ErrorPage />} />
                    <Route exact path={routes.menu_3} element={menu?.find(x => x.idx === 3) ? <Menu3 /> : <ErrorPage />} />
                    <Route exact path={routes.menu_4} element={menu?.find(x => x.idx === 4) ? <Menu4 /> : <ErrorPage />} />
                    <Route exact path={routes.menu_5} element={menu?.find(x => x.idx === 5) ? <Menu5 /> : <ErrorPage />} />
                    <Route exact path={routes.menu_6} element={menu?.find(x => x.idx === 6) ? <Menu6 /> : <ErrorPage />} />
                    <Route exact path={routes.menu_7} element={menu?.find(x => x.idx === 7) ? <Menu7 /> : <ErrorPage />} />
                    <Route exact path={routes.menu_8} element={menu?.find(x => x.idx === 8) ? <Menu8 /> : <ErrorPage />} />
                    <Route exact path={routes.menu_9} element={menu?.find(x => x.idx === 9) ? <Menu9 /> : <ErrorPage />} />
                    <Route exact path={routes.menu_10} element={menu?.find(x => x.idx === 10) ? <Menu10 /> : <ErrorPage />} />

                    {token && (
                        <>
                            <Route exact path={routes.profile} element={<Profile />} />
                            <Route exact path={routes.pay} element={<Pay />} />
                            <Route exact path={routes.pay_history} element={<PayHistory />} />
                            <Route exact path={routes.myart_history} element={<ArtHistory />} />
                            <Route exact path={routes.myart_gallery} element={<ArtGallery />} />


                        </>
                    )}

                    <Route exact path={'/payLoading'} element={<PayLoading />} />
                    <Route exact path={'/payFail'} element={<PayFail />} />

                    <Route exact path={routes.term} element={<Term />} />
                    <Route exact path={'*'} element={<ErrorPage />} />
                </Routes>

            </BrowserRouter>
        </>
    )
}

export default Router;